import { render } from "./Cancellations.vue?vue&type=template&id=502ba102&scoped=true"
import script from "./Cancellations.vue?vue&type=script&lang=js"
export * from "./Cancellations.vue?vue&type=script&lang=js"

import "./Cancellations.vue?vue&type=style&index=0&id=502ba102&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502ba102"]])

export default __exports__